import { SVGIconComponent } from './types';

export const EventNotificationEmail: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g id="timeline/event-notif-email" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M3.46341463,6 C3.2719122,6 3.08995122,6.03786 2.9222439,6.10096154 L11.4129756,12.9375 C11.7845366,13.2367846 12.199,13.2367846 12.5715122,12.9375 L21.0700488,6.09380769 C20.9052244,6.03341077 20.7251463,6 20.5365122,6 L3.46341463,6 Z M2.0152439,7.18269231 C2.00571659,7.24759615 2,7.31700692 2,7.38461538 L2,16.6153846 C2,17.3825077 2.65263415,18 3.46341463,18 L20.5365854,18 C21.3473659,18 22,17.3825077 22,16.6153846 L22,7.38461538 C22,7.31700692 21.9942834,7.24759615 21.9847561,7.18269231 L13.5242683,13.9903846 C12.6467805,14.6962154 11.3367561,14.6971154 10.4603659,13.9903846 L2.0152439,7.18269231 Z"
        id="Shape"
        fill="currentColor"
        fillRule="nonzero"
      ></path>
    </g>
  </svg>
);
